import TemplateView from "../../../TemplateView";
import {getStatusClassByType, getColorClassById, getStatusTypeClassByColorId} from "../../../workflowStatus/utils";
import WorkflowStatusIcon from "../../../workflowStatus/WorkflowStatusIcon";

export default class StatusHeader extends TemplateView {
    constructor({
        name = "",
        count = 0,
        type = -1,
        colorId = 0
    }) {
        super()

        this.name = name;
        this.count = count;
        this.type = type;
        this.colorId = colorId;
    }

    templateHtml() {
        return "<div class='statusHeader <%=statusClass%> <%=colorClass%>'>" +
               "  <div class='icon'></div>" +
               "  <div class='name'><%-name%></div>" +
               "  <div class='count <%=colorClass%>'><%=count%></div>" +
               "</div>"
    }

    afterRender() {
        new WorkflowStatusIcon(null, {
            colorId: this.colorId,
            type: this.type
        }).init(this.find('.icon'))
    }

    templateModel() {
        return {
            name: this.name,
            count: this.count,
            statusClass: getStatusClassByType(this.type),
            colorClass: getColorClassById(this.colorId),
            statusTypeIconClass: getStatusTypeClassByColorId(this.colorId)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/StatusHeader.js